// extracted by mini-css-extract-plugin
module.exports = {"title":"_311KHAjc","meta":"_2dBIOKNq","text":"_8TvaAXEE","cta":"_10y6U7Y-"};